<span
  class="flex-container flex-align-center menu-item nav"
  cdkOverlayOrigin
  tabindex="0"
  role="button"
  [attr.aria-label]="(entry.customTooltip$ | async) || (entry.name | icuTranslate)"
  [class.menu-item-active]="active$ | async"
  [class.hidden-menu-item]="!(showSubEntries$ | async)"
  [id]="'menu-entry-' + entry.name"
  #origin="cdkOverlayOrigin"
  (mouseenter)="open()"
  (mousedown)="navigate($event)"
  (keydown.enter)="navigate($event)"
>
  @if (entry.customImageUrl$ | async; as customImageUrl) {
    <img class="menu-item-custom-icon" [src]="customImageUrl" [alt]="entry.name | icuTranslate" />
  } @else {
    <i [nimbusIcon]="entry.icon"></i>
  }
  @if (entry.indicator) {
    @if ({ displayed: entry.indicator.displayed$ | async, displayedCount: entry.indicator.displayedCount$ | async }; as indicator) {
      @if (indicator.displayed) {
        <span class="menu-item-indicator" [class]="entry.indicator.class">
          @if (entry.indicator.icon) {
            <i [nimbusIcon]="entry.indicator.icon"></i>
          }
          @if (indicator.displayedCount) {
            {{ indicator.displayedCount }}
          }
        </span>
      }
    }
  }
</span>

@if (active$ | async) {
  <ul [class.slide-in-top]="showAnimation$ | async">
    @for (subEntry of entry.subEntries; track subEntry) {
      @if (subEntry.filter$ | async) {
        <li class="sub-entry">
          <nimbus-menu-item [entry]="subEntry" [class]="entry.subClass"></nimbus-menu-item>
        </li>
      }
    }
  </ul>
}

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayDelay
  cdkConnectedOverlayPanelClass="menu-overlay"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="connectedPositions"
  (attach)="overlayOpened()"
  (detach)="overlayClosed()"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
>
  <div class="menu-overlay-container">
    @if (overlayContent) {
      <ng-container *ngTemplateOutlet="overlayContent"></ng-container>
    } @else {
      @if ((showTooltip$ | async) || !(showSubEntries$ | async)) {
        <div class="menu-overlay-callout"></div>
        <span class="tooltip">{{ (entry.customTooltip$ | async) || (entry.name | icuTranslate) }}</span>
      } @else {
        <div class="menu-multiple-item-overlay-callout"></div>
        <ul>
          @for (subEntry of entry.subEntries; track subEntry) {
            @if (subEntry.filter$ | async) {
              <li class="sub-entry">
                <div [id]="'menu-sub-entry-' + subEntry.name" class="flex-container flex-align-center-left menu-overlay-item">
                  @let subCustomImageUrl = subEntry.customImageUrl$ | async;
                  @if (subCustomImageUrl) {
                    <img class="menu-item-custom-icon" [src]="subCustomImageUrl" [alt]="subEntry.name | icuTranslate" />
                  } @else {
                    <i [nimbusIcon]="subEntry.icon"></i>
                  }
                  <span [routerLink]="subEntry.path">{{ (subEntry.customTooltip$ | async) || (subEntry.name | icuTranslate) }}</span>
                </div>
              </li>
            }
          }
        </ul>
      }
    }
  </div>
</ng-template>
